import React, { lazy, Suspense } from 'react';

import { createBrowserRouter, RouterProvider } from 'react-router-dom';

const UserLayout = lazy(() => import('../page/UserLogInRegister/Layout'));
const RootLayout = lazy(() => import('../layout/Layout'));
const Login = lazy(() => import('../page/UserLogInRegister/Login'));
const Dashboard = lazy(() => import('../page/Dashboard/Dashboard'));
const Loading = lazy(() => import('../component/Loader/Loading'));
const ManageRole = lazy(() => import('../page/ManageRole/ManageRole'));
const ManageMenu = lazy(() => import('../page/ManageMenu/ManageMenu'));
const ManageUsers = lazy(() => import('../page/MenageUsers/ManageUsers'));
const ProductManage = lazy(() => import('../page/ProductManage/ProductManage'));
const ManageCallDisposition = lazy(() => import('../page/ManageCallDisposition/ManageCallDisposition'));
const ManageCall = lazy(() => import('../page/Call/ManageCall'));
const ManageOperatingSystem = lazy(() => import('../page/ManageOperatingSystem/ManageOperatingSystem'));
const AsignMenu = lazy(() => import('../page/ManageMenu/AsignMenu'));
const ManageCallPerMisition = lazy(() => import('../page/ManageCallPerMisition/ManageCallPerMisition'));
const Register = lazy(() => import('../page/UserLogInRegister/Register'));
const ManageCustomer = lazy(() => import('../page/Customer/ManageCustomer'));
const CustomeryViewHistory = lazy(() => import('../page/Customer/CustomeryViewHistory'));
const CustomerPermission = lazy(() => import('../page/Customer/CustomerPermission'));
const IpAddressSecurity = lazy(() => import('../page/IpAddressSecurity/IpAddressSecurity'));
const KnowledgeBase = lazy(() => import('../page/KnowledgeBase/KnowledgeBase'));
const MyNotes = lazy(() => import('../page/MyNotes/MyNotes'));
const Reporting = lazy(() => import('../page/Reporting/Reporting'));
const ManageChatBox = lazy(() => import('../page/Chat/ManageChatBox'));
const Invioce = lazy(() => import('../page/Invoice/ManageInvioce'));
const ManageSubInvioce = lazy(() => import('../page/Invoice/ManageSubInvioce'));
const ManagePaymentMerchant = lazy(() => import('../page/PaymentMerchant/MangePaymentMerchant'));
const StatusMaster = lazy(() => import('../page/StatusMaster/StatusMaster'));




const router = createBrowserRouter([
  {
    path: "/portal",
    element: <RootLayout />,
    children: [
      { index: true, element: <Dashboard /> },
      {
        path: "dashboard",
        element: (
          <Suspense fallback={<Loading />}>
            <Dashboard />
          </Suspense>
        ),
      },
      {
        path: "role",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageRole />
          </Suspense>
        ),
      },
      {
        path: "menu",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageMenu />
          </Suspense>
        ),
      },
      {
        path: "assign-menu",
        element: (
          <Suspense fallback={<Loading />}>
            <AsignMenu />
          </Suspense>
        ),
      },
      {
        path: "manage-user",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageUsers />
          </Suspense>
        ),
      },
      {
        path: "manage-product",
        element: (
          <Suspense fallback={<Loading />}>
            <ProductManage />
          </Suspense>
        ),
      },
      {
        path: "manage-call-disposition",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageCallDisposition />
          </Suspense>
        ),
      },
      {
        path: "call-manage",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageCall />
          </Suspense>
        ),
      },
      {
        path: "operating-system-manage",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageOperatingSystem />
          </Suspense>
        ),
      },
      {
        path: "call-permission",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageCallPerMisition />
          </Suspense>
        ),
      },
      {
        path: "chat",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageChatBox />
          </Suspense>
        ),
      },
      {
        path: "all-customer",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageCustomer />
          </Suspense>
        ),
      },
      {
        path: "customer-history/:id?",
        element: (
          <Suspense fallback={<Loading />}>
            <CustomeryViewHistory />
          </Suspense>
        ),
      },
      {
        path: "customer-permission",
        element: (
          <Suspense fallback={<Loading />}>
            <CustomerPermission />
          </Suspense>
        ),
      },
      {
        path: "ip-whitelist",
        element: (
          <Suspense fallback={<Loading />}>
            <IpAddressSecurity />
          </Suspense>
        ),
      },
      {
        path: "knowledge-base",
        element: (
          <Suspense fallback={<Loading />}>
            <KnowledgeBase />
          </Suspense>
        ),
      },
      {
        path: "my-notes",
        element: (
          <Suspense fallback={<Loading />}>
            <MyNotes />
          </Suspense>
        ),
      },
      {
        path: "reporting",
        element: <Suspense fallback={<Loading />}><Reporting /></Suspense>,
      },
      {
        path: "invoice",
        element: (
          <Suspense fallback={<Loading />}>
            <Invioce />
          </Suspense>
        ),
      },
      {
        path: "sub-invoice",
        element: (
          <Suspense fallback={<Loading />}>
            <ManageSubInvioce />
          </Suspense>
        ),
      },
      {
        path: "payment-merchant",
        element: (
          <Suspense fallback={<Loading />}>
            <ManagePaymentMerchant />
          </Suspense>
        ),
      },
      {
        path: "status-master",
        element: (
          <Suspense fallback={<Loading />}>
            <StatusMaster />
          </Suspense>
        ),
      },
    ],
  },
  {
    path: "/portal",
    element: <UserLayout />,
    children: [
      {
        path: "sign-in",
        element: (
          <Suspense fallback={<Loading />}>
            <Login />
          </Suspense>
        ),
      },
      {
        path: "sign-up",
        element: (
          <Suspense fallback={<Loading />}>
            <Register />
          </Suspense>
        ),
      }
    ],
  },
  {
    path: "*",
    element: <UserLayout />,
    children: [
      {
        path: "sign-in",
        element: (
          <Suspense fallback={<Loading />}>
            <Login />
          </Suspense>
        ),
      },
    ],
  },
]);

export default function PrivateRoutes() {



  return <RouterProvider router={router} />;
}
